import { postData } from 'helpers/RequestHelper';

const resendLinkToPay = (shortenedUrl, sendMethod) => {
  return postData({
    url: '/api/v1/link_to_pay/resend',
    body: { send_method: sendMethod, shortened_url: shortenedUrl },
    catchErrors: false
  }).catch((error) => {
    window.Raven.captureException(error);
    return error?.response;
  });
};

export { resendLinkToPay };
